import * as React from "react";
import type { SVGProps } from "react";
const SvgGolfCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#golf-cart_svg__a)">
      <path d="M6 21.99a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M18 21.99a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      <path d="M21 17.99H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.76a10.5 10.5 0 0 1 4.47 1h4.15l1.73-3.45a1 1 0 0 1 .63-.52 1 1 0 0 1 .81.14l3 2a1 1 0 0 1 .45.83v5a1 1 0 0 1-1 1m-17-2h16v-3.46l-1.61-1.08-1.5 3a1 1 0 0 1-.89.54h-5a1 1 0 0 1-.45-.11 8.6 8.6 0 0 0-3.79-.89H4z" />
      <path d="M17 11.99a.93.93 0 0 1-.45-.11l-2-1a1 1 0 0 1-.44-1.34 1 1 0 0 1 1.34-.44l2 1a1 1 0 0 1-.45 1.89" />
      <path d="M13 11.99a.94.94 0 0 1-.55-.17 1 1 0 0 1-.28-1.38l2-3a1 1 0 0 1 1.38-.28 1 1 0 0 1 .28 1.38l-2 3a1 1 0 0 1-.83.45M20 11.99a1 1 0 0 1-1-.73l-2-7a1 1 0 0 1 .69-1.23 1 1 0 0 1 1.23.69l2 7a1 1 0 0 1-.69 1.23.8.8 0 0 1-.23.04" />
      <path d="M3 5.08a1 1 0 0 1-.27-1.97 37.9 37.9 0 0 1 16.52-.39l1.92.38a1 1 0 0 1 .78 1.18 1 1 0 0 1-1.18.79l-1.91-.39a35.9 35.9 0 0 0-15.65.37z" />
      <path d="M5 13.99a1 1 0 0 1-1-1v-9a1 1 0 0 1 2 0v9a1 1 0 0 1-1 1" />
      <path d="M8 13.99a1 1 0 0 1-1-.76l-1-4a1 1 0 0 1 1.94-.48l1 4a1 1 0 0 1-.73 1.21z" />
      <path d="M7 9.99H3a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="golf-cart_svg__a">
        <path fill="#fff" d="M2 2h20v19.99H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGolfCart;
